const useCheckJailbreakStatus = () => false;

export { useCheckJailbreakStatus };
